/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconMist = createReactComponent("outline", "mist", "IconMist", [["path", { "d": "M5 5h3m4 0h9", "key": "svg-0" }], ["path", { "d": "M3 10h11m4 0h1", "key": "svg-1" }], ["path", { "d": "M5 15h5m4 0h7", "key": "svg-2" }], ["path", { "d": "M3 20h9m4 0h3", "key": "svg-3" }]]);

export { IconMist as default };
//# sourceMappingURL=IconMist.mjs.map
